{
  "REPORT": {
    "HEADER": "المحادثات",
    "LOADING_CHART": "تحميل بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_CONVERSATION_REPORTS": "تنزيل تقارير المحادثات",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(الإجمالي)"
      },
      "REPLY_TIME": {
        "NAME": "وقت انتظار العميل",
        "TOOLTIP_TEXT": "وقت الانتظار هو {metricValue} (بناء على ردود {conversationCount})",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "آخر 7 أيام",
      "LAST_14_DAYS": "آخر 14 يوماً",
      "LAST_30_DAYS": "آخر 30 يوماً",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "آخر 3 أشهر",
      "LAST_6_MONTHS": "آخر 6 أشهر",
      "LAST_YEAR": "العام الماضي",
      "CUSTOM_DATE_RANGE": "تحديد نطاق المدة"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "تجميع بواسطة",
    "DURATION_FILTER_LABEL": "المدة",
    "GROUPING_OPTIONS": {
      "DAY": "اليوم",
      "WEEK": "الأسبوع",
      "MONTH": "الشهر",
      "YEAR": "السنة"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "اليوم"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "اليوم"
      },
      {
        "id": 2,
        "groupBy": "الأسبوع"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "اليوم"
      },
      {
        "id": 2,
        "groupBy": "الأسبوع"
      },
      {
        "id": 3,
        "groupBy": "الشهر"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "اليوم"
      },
      {
        "id": 2,
        "groupBy": "الأسبوع"
      },
      {
        "id": 3,
        "groupBy": "الشهر"
      }
    ],
    "BUSINESS_HOURS": "ساعات العمل",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "لم يتم العثور على النتائج"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "Load more",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "غير مسند",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "نظرة عامة للوكلاء",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "جاري جلب بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_AGENT_REPORTS": "تنزيل تقارير الوكيل",
    "FILTER_DROPDOWN_LABEL": "اختر وكيل",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "البحث عن وكلاء"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "آخر 7 أيام"
      },
      {
        "id": 1,
        "name": "آخر 30 يوماً"
      },
      {
        "id": 2,
        "name": "آخر 3 أشهر"
      },
      {
        "id": 3,
        "name": "آخر 6 أشهر"
      },
      {
        "id": 4,
        "name": "العام الماضي"
      },
      {
        "id": 5,
        "name": "تحديد نطاق المدة"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "نظرة عامة على التسميات",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "تحميل بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_LABEL_REPORTS": "تحميل تقارير التسمية",
    "FILTER_DROPDOWN_LABEL": "حدد التسمية",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "ابحث عن تصنيفات"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "آخر 7 أيام"
      },
      {
        "id": 1,
        "name": "آخر 30 يوماً"
      },
      {
        "id": 2,
        "name": "آخر 3 أشهر"
      },
      {
        "id": 3,
        "name": "آخر 6 أشهر"
      },
      {
        "id": 4,
        "name": "العام الماضي"
      },
      {
        "id": 5,
        "name": "تحديد نطاق المدة"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "نظرة عامة على صندوق الوارد",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "تحميل بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_INBOX_REPORTS": "تحميل تقارير صندوق الوارد",
    "FILTER_DROPDOWN_LABEL": "اختر صندوق الوارد",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "آخر 7 أيام"
      },
      {
        "id": 1,
        "name": "آخر 30 يوماً"
      },
      {
        "id": 2,
        "name": "آخر 3 أشهر"
      },
      {
        "id": 3,
        "name": "آخر 6 أشهر"
      },
      {
        "id": 4,
        "name": "العام الماضي"
      },
      {
        "id": 5,
        "name": "تحديد نطاق المدة"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "نظرة عامة للفريق",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "تحميل بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_TEAM_REPORTS": "تحميل تقارير الفريق",
    "FILTER_DROPDOWN_LABEL": "اختيار فريق",
    "FILTERS": {
      "ADD_FILTER": "إضافة تصفية",
      "CLEAR_ALL": "مسح الكل",
      "NO_FILTER": "لا توجد عوامل تصفية متوفرة",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "البحث عن فريق"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "آخر 7 أيام"
      },
      {
        "id": 1,
        "name": "آخر 30 يوماً"
      },
      {
        "id": 2,
        "name": "آخر 3 أشهر"
      },
      {
        "id": 3,
        "name": "آخر 6 أشهر"
      },
      {
        "id": 4,
        "name": "العام الماضي"
      },
      {
        "id": 5,
        "name": "تحديد نطاق المدة"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "تقارير CSAT",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "تحميل تقرير رضاء خدمة العملاء",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "ADD_FILTER": "إضافة تصفية",
      "CLEAR_ALL": "مسح الكل",
      "NO_FILTER": "لا توجد عوامل تصفية متوفرة",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "البحث عن وكلاء",
        "INBOXES": "Search inboxes",
        "TEAMS": "البحث عن فريق",
        "RATINGS": "البحث في التقييمات"
      },
      "AGENTS": {
        "LABEL": "وكيل الدعم"
      },
      "INBOXES": {
        "LABEL": "صندوق الوارد"
      },
      "TEAMS": {
        "LABEL": "الفريق"
      },
      "RATINGS": {
        "LABEL": "التقييم"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "جهات الاتصال",
        "AGENT_NAME": "وكيل الدعم",
        "RATING": "التقييم",
        "FEEDBACK_TEXT": "تعليق الملاحظات",
        "CONVERSATION": "المحادثات",
        "CUSTOMER": "عميل",
        "RESPONSE": "الردود",
        "HANDLED_BY": "تمت معالجتها بواسطة"
      },
      "UNKNOWN_CUSTOMER": "عميل غير معروف"
    },
    "NO_AGENT": "لم يتم تعيين وكيل",
    "NO_FEEDBACK": "لا توجد ملاحظات مقدمة",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "إجمالي الردود",
        "TOOLTIP": "العدد الإجمالي للردود التي تم جمعها"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "درجة الرضا",
        "TOOLTIP": "العدد الإجمالي للردود الإيجابية/ العدد الإجمالي للردود * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "معدل الاستجابة",
        "TOOLTIP": "العدد الإجمالي للردود / العدد الإجمالي لرسائل الاستقصاء التي أرسلتها CSAT * 100"
      },
      "RATING_DISTRIBUTION": "توزيع التقييم"
    },
    "REVIEW_NOTES": {
      "TITLE": "ملاحظات المراجعة",
      "PLACEHOLDER": "إضافة ملاحظات مراجعة حول هذا التقييم...",
      "SAVE": "حفظ",
      "CANCEL": "إلغاء",
      "SAVING": "جاري الحفظ...",
      "SAVED": "تم حفظ الملاحظات بنجاح",
      "SAVE_ERROR": "فشل في حفظ الملاحظات",
      "UPDATED_BY": "تم التحديث بواسطة {name} {time}",
      "UPDATED_BY_LABEL": "تم التحديث بواسطة",
      "PAYWALL": {
        "TITLE": "قم بالترقية لإضافة ملاحظات المراجعة",
        "AVAILABLE_ON": "ميزة مراجعة الملاحظات متاحة فقط في الخطط Business و Enterprise.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "الترقية الآن",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "نظرة عامة",
    "LIVE": "مباشر",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "المحادثات المفتوحة",
      "LOADING_MESSAGE": "جارٍ تحميل مقاييس المحادثات...",
      "OPEN": "فتح",
      "UNATTENDED": "بدون حضور",
      "UNASSIGNED": "غير مسند",
      "PENDING": "معلق"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "تنزيل التقرير"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "تنزيل التقرير"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "المحادثات من قبل الوكلاء",
      "LOADING_MESSAGE": "جاري تحميل مقاييس الوكيل...",
      "NO_AGENTS": "لا توجد أي محادثات من قبل الوكلاء",
      "TABLE_HEADER": {
        "AGENT": "موظف الدعم",
        "OPEN": "فتح",
        "UNATTENDED": "بدون حضور",
        "STATUS": "الحالة"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "الفريق",
        "OPEN": "فتح",
        "UNATTENDED": "بدون حضور",
        "STATUS": "الحالة"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "حالة الوكيل",
      "ONLINE": "متصل",
      "BUSY": "مشغول",
      "OFFLINE": "غير متصل"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "إضافة فلتر",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "لم يتم العثور على النتائج",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "اسم الموظف",
        "INBOXES": "اسم صندوق الوارد",
        "LABELS": "اسم الوسم",
        "TEAMS": "اسم الفريق"
      },
      "SLA": "SLA Policy",
      "INBOXES": "صندوق الوارد",
      "AGENTS": "موظف الدعم",
      "LABELS": "الوسم",
      "TEAMS": "الفريق"
    },
    "WITH": "مع",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "المحادثات",
        "AGENT": "وكيل الدعم"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "صندوق الوارد",
    "AGENT": "وكيل الدعم",
    "TEAM": "الفريق",
    "LABEL": "الوسم",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "عدد مرات الإغلاق",
    "CONVERSATIONS": "عدد المحادثات"
  }
}
